export default __webpack_public_path__ + "static/media/GalleryFirstCAFullSize.f1f238a0.jpg";